import {
    WorkspaceAssignment,
    WorkspaceAssignmentBase,
} from "../../types/workspace";
import { UserWorkspaceRole } from "../../userWorkspaceRoles";
import { UserDto } from "../user/user.dto";

export class WorkspaceAssignmentDto {
    static deserialize(dto: WorkspaceAssignmentDto): WorkspaceAssignment {
        return {
            ...dto,
            user: UserDto.deserialize(dto.user),
        };
    }

    user: UserDto;
    role: UserWorkspaceRole;
    organizationId: string | null;

    constructor(member: WorkspaceAssignmentBase) {
        this.user = new UserDto(member.user);
        this.role = member.role;
        this.organizationId = member.organizationId ?? null;
    }
}
